import { pick } from 'lodash';
import getPropKeys from './getPropKeys';

export default function pickProps(props, ...keysOrComponents) {
    const keys = getPropKeys(...keysOrComponents);
    if (keys.length === 0) return {};
    return pick(props, keys);
}
